import { FC, useEffect } from "react";
import { Projeto } from "../types";
import { Pedido } from "src/components/vendas/types";
import { Box, Button, Icon, Typography } from "@mui/material";
import "./styles.css";
import EngineeringIcon from '@mui/icons-material/Engineering';
import { STATUS_PROJETO, TIPO_SERVICO_TURNKEY } from "../constants";
import { SugestaoLayout } from "./layout";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import { isMobile } from "../utils/deviceUtils";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { EnumEtapaVenda, EnumSituacaoPedido, EnumSituacaoProjeto, verificaProjetoExpirado } from "../utils/checarStatusAcao";

interface SugestaoAcoesProperties {
  projeto?: Projeto
  handleAcao: (acao: AcoesSugeridas, projeto: Projeto) => void
}

export enum AcoesSugeridas {
  CONFIRMAR_VISITA_TECNICA = "confirmar_visita_tecnica",
  ENVIAR_PAGAMENTO = "enviar_pagamento",
  FINALIZAR = "finalizar",
  REATIVAR = "reativar",
  ENVIAR_DOCUMENTO_SERVICO = "enviar_documento_servico"
}
export const STATUS_COMISSIONAMENTO = [
    {
        text: "Aguardando Documentação",
        value: "aguardando_documentacao",
    },
    {
        text: "Documentação enviada/processando",
        value: "documentacao_enviada_processando",
    },
    {
        text: "Documentação Aprovada",
        value: "documentacao_aprovada",
    },
    {
        text: "Aguardando Finalização do Projeto",
        value: "aguardando_finalizacao",
    }
]
const SugestaoAcoes: FC<SugestaoAcoesProperties> = ({ projeto, handleAcao }) => {
  const permissoes = PermissionUtil.getPermissions();
  const regraVisita = () => {
    let exibe = false;
    if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_CONFIRMAR_VISITA_TECNICA, permissoes)) {
      return exibe;
    }
    if (projeto?.tipo === "vertical") {
      return exibe;
    }
    if (projeto?.tipo !== "kit") {
      if (projeto?.data_visita_tecnica === null) {
        switch (projeto?.situacao) {
            case EnumSituacaoProjeto.PENDENTE: 
                exibe = true;
                break;
        }
        if (exibe) { 
          switch (projeto?.etapa_venda) {
              case EnumEtapaVenda.PRE_ORCAMENTO: 
                  exibe = true;
                  break;
              case EnumEtapaVenda.SLA_ENGENHARIA: 
                  exibe = true;
                  break;
              default:
                  exibe = false;
                  break;
          }
        }
      } 
    } else {
      exibe = false;
    }
    if (exibe && verificaProjetoExpirado(projeto as Projeto)) {
      exibe = false;
    }

    const componentesValidos = projeto?.componentes?.filter(componente => !!componente && typeof componente === 'object' && Object.keys(componente)?.length > 0)?.filter(Boolean);
    if (!projeto?.valor_projeto && !componentesValidos?.length) {
      exibe = false;
    }

    return exibe;
  }
  const regraEnviarPagamento = () => {
    let exibe = false;
    if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_ENVIAR_PAGAMENTO, permissoes)) {
      return exibe;
    }
    if (projeto?.tipo === "vertical") {
      return exibe;
    }
    if (projeto?.tipo === "kit") {
      return exibe;
    } else {
      exibe = false;
      switch (projeto?.situacao) {
          case EnumSituacaoProjeto.PENDENTE: 
              exibe = true;
              break;
      }
      if (exibe) {
        exibe = false;
        if (!verificaProjetoExpirado(projeto as Projeto)) {
          switch (projeto?.etapa_venda) {
            case EnumEtapaVenda.PRE_ORCAMENTO:
                if (projeto.data_visita_tecnica !== null){
                  exibe = true;
                }
                break;
          }
        }
      }
    }
    return exibe;
  }
  const regraFinalizar = () => {
    if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_FINALIZAR, permissoes)) {
      return false;
    }
  
    switch (projeto?.status_projeto) {
      case EnumEtapaVenda.ENTREGUE:
          return true;
    }
  }
  const regraReativar = () => {
    const pedido = projeto?.pedidos ? projeto.pedidos[0] : null;
    let exibe = false;
    if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_REATIVAR, permissoes) || projeto?.situacao === 'cancelado') {
      return exibe;
    }
    verificaProjetoExpirado(projeto as Projeto) ? exibe = true : exibe = false;
    if (exibe && pedido && pedido?.data_expiracao_pagamento) {
      exibe = false;
    }
    return exibe; 
  }
  const regraEnviarDocumentoServico = () => {
    const pedido = projeto?.pedidos ? projeto.pedidos[0] : null;
    let exibe = false;
    if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_DOCUMENTO_SERVICO, permissoes)) {
      return exibe;
    }
  
    if (!!projeto?.dados_finalizar_renovigi && projeto?.valor_servico !== 0 && projeto?.servico !== TIPO_SERVICO_TURNKEY) {
      return true;
    }

    switch (pedido?.situacao){
      case EnumSituacaoPedido.FINALIZADO:
        if (projeto?.valor_servico !== 0 && projeto?.servico !== TIPO_SERVICO_TURNKEY){
          return true;
        }
    }
  }
  const avaliarRegras = () => {
    //avalia regras para exibir sugestões de ações para o projeto
    if (regraVisita()) {
      return AcoesSugeridas.CONFIRMAR_VISITA_TECNICA;
    }else if(regraEnviarPagamento()){
      return AcoesSugeridas.ENVIAR_PAGAMENTO;
    }else if(regraFinalizar()){
      return AcoesSugeridas.FINALIZAR;
    }else if(regraReativar()){
      return AcoesSugeridas.REATIVAR;
    }else if(regraEnviarDocumentoServico()){
      if(projeto?.status_comissionamento === "aguardando_documentacao" || !projeto?.documentos_servico){
        return AcoesSugeridas.ENVIAR_DOCUMENTO_SERVICO;
      }
    }
  }
  const renderSugestao = () => {
    const acao = avaliarRegras();
    switch (acao) {
      case AcoesSugeridas.CONFIRMAR_VISITA_TECNICA:
        return (<SugestaoLayout>
          <Box style={{display: "flex", alignItems: "center", justifyContent: "end"}}>
            <Button className="btn-confirmar-visita" onClick={()=>{
              handleAcao(AcoesSugeridas.CONFIRMAR_VISITA_TECNICA, projeto as Projeto)
            }}>
            <span className="btn-icon">
            <EngineeringIcon />
            </span>
            <span className="btn-text">
            {"CONFIRMAR VISITA TÉCNICA"}
            </span>
            </Button>
          </Box>
        </SugestaoLayout>)
      case AcoesSugeridas.ENVIAR_PAGAMENTO:
        return (<SugestaoLayout>
          <Box style={{display: "flex", alignItems: "center", justifyContent: "end"}}>
            <Button className="btn-confirmar-visita" onClick={()=>{
              handleAcao(AcoesSugeridas.ENVIAR_PAGAMENTO, projeto as Projeto)
            }}>
            <span className="btn-icon">
            <AttachMoneyIcon />
            </span>
            <span className="btn-text">
            {"ENVIAR PARA PAGAMENTO"}
            </span>
            </Button>
          </Box>
        </SugestaoLayout>)        
      case AcoesSugeridas.FINALIZAR:
        return (<SugestaoLayout>
          <Box style={{display: "flex", alignItems: "center", justifyContent: "end"}}>
            <Button className="btn-confirmar-visita" onClick={()=>{
              handleAcao(AcoesSugeridas.FINALIZAR, projeto as Projeto)
            }}>
            <span className="btn-icon">
            <TaskAltIcon />
            </span>
            <span className="btn-text">
            {"FINALIZAR PROJETO"}
            </span>
            </Button>
          </Box>
        </SugestaoLayout>)
      case AcoesSugeridas.REATIVAR:
        return (<SugestaoLayout>
          <Box style={{display: "flex", alignItems: "center", justifyContent: "end"}}>
            <Button className="btn-confirmar-visita" onClick={()=>{
              handleAcao(AcoesSugeridas.REATIVAR, projeto as Projeto)
            }}>
            <span className="btn-icon">
            <RefreshIcon />
            </span>
            <span className="btn-text">
            {"REATIVAR PROJETO"}
            </span>
            </Button>
          </Box>
        </SugestaoLayout>)
      case AcoesSugeridas.ENVIAR_DOCUMENTO_SERVICO:
        return (<SugestaoLayout>
          <Box style={{display: "flex", alignItems: "center", justifyContent: "end"}}>
            <Button className="btn-confirmar-visita" onClick={()=>{
              handleAcao(AcoesSugeridas.ENVIAR_DOCUMENTO_SERVICO, projeto as Projeto)
            }}>
            <span className="btn-icon">
            <RequestPageIcon />
            </span>
            <span className="btn-text">
            {"ENVIAR DOCUMENTOS DE SERVIÇO"}
            </span>
            </Button>
          </Box>
        </SugestaoLayout>)
      default:
        return (<></>)
    }
  } 
  return (<>
    {renderSugestao()}
  </>)
}

export { SugestaoAcoes }
